var mentions_default = {
  "mentionPalette": "_9Uxzb",
  "mention": "_8dGPz",
  "mentionViewer": "_1luVq",
  "mentionSuggestionsEntry": "UDbnv",
  "mentionSuggestionsEntryFocused": "suhLp",
  "mentionSuggestionsEntryText": "CedqS",
  "mentionSuggestionsEntryAvatar": "_7LTkz",
  "mentionSuggestions": "mnzs-",
  "cursorDefault": "g3IbB",
  "cursorPointer": "W-0QR"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
